import React, { useState, useEffect, useRef } from "react";
import PopUpPanel from "../../components/PopUpPanel/PopUpPanel";

import "./RestrictedCustomisationPopup.scss";
import CustomisationControls from "../../components/CustomisationControls/CustomisationControls";
import AddDisruptor from "../Campaigns/AddDisruptor";



const RestrictedCustomisationPopup = (props) => {
    let featureData = null;
    for (let i =  0; i < props.campaignData.features.length; i++) {
        if (props.campaignData.features[i]._id === props.featureId) {
            featureData = props.campaignData.features[i];
            break;
        }
    }

    console.log("RESTRICTED CUSTOMISATION POPUP", featureData, props.customisationVars, props.featureId, props.campaignData);
    console.log("RESTRICTED CUSTOMISATION POPUP PROPS", props);
    const [editedCustomisationVars, setEditedCustomisationVars] = useState(props.customisationVars);
    useEffect(() => {
        setEditedCustomisationVars(JSON.parse(JSON.stringify(props.customisationVars)));
    }, [props.customisationVars]);

    // Adding disruptors
    const [showAddDistruptor, setShowAddDistruptor] = useState(false);
    const disruptorsUpdatedCallback = useRef(null);
    const existingDisruptorAddedCallback = useRef(null);

    const lastDisruptorAdded = useRef(null);
    const lastFeatureListUpdate = useRef(null);
    const [buildLeaderboard, setBuildLeaderboard] = useState(false);
    const [newDisruptorLabel, setNewDisruptorLabel] = useState(null);

    const addDisruptor = (completedCallback, addExistingCallback, isLeaderboard=false, disruptorLabel = null) => {
        disruptorsUpdatedCallback.current = completedCallback;
        existingDisruptorAddedCallback.current = addExistingCallback;

        lastDisruptorAdded.current = null;
        lastFeatureListUpdate.current = null;
        setBuildLeaderboard(isLeaderboard);
        setNewDisruptorLabel(disruptorLabel);
        setShowAddDistruptor(true);
    };
    const closeAddDisruptor = () => {setShowAddDistruptor(false)};

    const sizeStyle = {};
    const scrollSizeStyle = {};
    if (props.basicMode) {
        sizeStyle.width = 'fit-content';
        sizeStyle.minWidth = 'fit-content';
        sizeStyle.maxWidth = 'fit-content';
        sizeStyle.height = 'fit-content';
        sizeStyle.minHeight = 'fit-content';
        sizeStyle.maxHeight = 'fit-content';

        scrollSizeStyle.width = 'fit-content';
        scrollSizeStyle.minWidth = '40rem';
        scrollSizeStyle.maxWidth = '80vw';
        scrollSizeStyle.height = 'fit-content';
        scrollSizeStyle.minHeight = '5rem';
        scrollSizeStyle.maxHeight = '70vh';
    }
    /* if (props.width) {
        sizeStyle.width = props.width;
        sizeStyle.minWidth = props.minWidth ?? props.width;
    }
    if (props.height) {
        sizeStyle.height = props.height;
        // if (!props.maxHeight) {
            sizeStyle.minHeight = props.minHeight ?? props.height;
        // }
    }
    if (props.maxHeight) {
        sizeStyle.maxHeight = props.maxHeight;
    } */

    return (
        <>
            <PopUpPanel closePanelFunc={props.closePanelFunc} className="restricted-customisation-popup" style={sizeStyle}>
                <h1>{props.title}</h1>
                <div className="restricted-customisation-popup__scroll-area" style={scrollSizeStyle}>
                    <CustomisationControls
                        restrictedCustomisation = {{tab: props.tab, group: props.group, family: props.family, item: props.item, itemIndex: props.itemIndex, var: props.var}}
                        tabId={props.tab}
                        controlsData={featureData.feature.customisation}
                        customisationVars={editedCustomisationVars}
                        featureId={props.featureId}
                        featureData={featureData}
                        campaignData={props.campaignData}
                        advancedMode={props.advancedMode || true}
                        addDisruptor={addDisruptor}
                        basicMode={props.basicMode || false}
                        singleColumn={props.singleColumn || false}
                    />
                </div>
                <button className="standard-button save-button" 
                    onClick={
                        () => {
                            console.log("Save restricted customisations: ", props.customisationVars, editedCustomisationVars);
                            if (props.basicMode) {
                                props.saveCustomisationVars(editedCustomisationVars.current[props.featureId], {tab: props.tab, group: props.group, family: props.family, item: props.item, itemIndex: props.itemIndex, var: props.var}, props.basicModeItemData, props.basicModeCompletedCallback);
                            } else {
                                props.customisationVars.current[props.featureId] = editedCustomisationVars.current[props.featureId];
                                props.saveCustomisationVars(props.customisationVars, props.featureId);
                            }
                            props.closePanelFunc();
                        }
                    }
                >Save Changes</button>
            </PopUpPanel>
            {showAddDistruptor &&
                <AddDisruptor
                    closePanelFunc={closeAddDisruptor} 
                    campaignId={props.campaignId} 
                    addSelectedFeatureToListFunc={() => {}}
                    addExistingDisruptorToListFunc={existingDisruptorAddedCallback.current}
                    campaignTier={props.campaignData.campaignTier}
                    isIntro={false}
                    isOutro={false}
                    chainableOnly={true}
                    showSelectExistingOption={true}
                    campaignFeatures={props.campaignData.features}
                    buildLeaderboard={buildLeaderboard}
                    disruptorContentLabel={newDisruptorLabel}
                    isRestricted={true}
                />
            }
        </>
    )
}

export default RestrictedCustomisationPopup;
